import { cn } from "@/lib/utils";

/**
 * A thin horizontal rule between editorial sections. Matches the
 * `Divider` from MyJarvis Dashboard's DashboardArchitecturePage —
 * generous vertical breathing room, single soft hairline.
 */
export function EditorialDivider({ className }: { className?: string }) {
  return (
    <hr
      role="presentation"
      className={cn(
        "my-12 border-0 border-t border-stone-200/80",
        className,
      )}
    />
  );
}
